import React, { useEffect, useRef } from "react";
import oldimg from "../images/old1.jpg";
import newimg from "../images/new1.jpg";
import "./aboutUs.css";

export default function AboutUs() {
  const oldImgRef = useRef(null);
  const oldTextRef = useRef(null);
  const newImgRef = useRef(null);
  const newTextRef = useRef(null);

  useEffect(() => {
    const animateIn = (element, className) => {
      if (!element) return;
      element.classList.remove(className);
      void element.offsetWidth;
      element.classList.add(className);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (entry.target === oldImgRef.current) animateIn(entry.target, 'slide-in-left');
            if (entry.target === oldTextRef.current) animateIn(entry.target, 'slide-in-right');
            if (entry.target === newTextRef.current) animateIn(entry.target, 'slide-in-left');
            if (entry.target === newImgRef.current) animateIn(entry.target, 'slide-in-right');
          }
        });
      },
      { threshold: 0.5 }
    );

    [oldImgRef, oldTextRef, newImgRef, newTextRef].forEach(ref => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => {
      [oldImgRef, oldTextRef, newImgRef, newTextRef].forEach(ref => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, []);

  return (
    <div className="about-us-container">
      <div className="center-container">
        <div className="left-column">
          <h2>About Us</h2>
          <p>
            <strong><em>Tulsidas Gordhandas Mistri</em></strong> laid the foundation of the family’s legacy by starting a humble furniture
            business with a strong focus on craftsmanship, quality, and trust.
            <br /><br />
            With deep respect for his grandfather’s vision, <strong><em>Chirag Mistri</em></strong> stepped in to take the legacy forward.
            Combining traditional values with modern innovation, he began expanding the business — bringing in new
            designs, materials, and technology to meet contemporary demands.
          </p>
        </div>

        <div className="right-column">
          <div className="timeline-item old">
            <div className="image" ref={oldImgRef}>
              <img src={oldimg} alt="Old Shop" className="box-shadow" />
            </div>
            <div className="timeline-point"></div>
            <div className="text" ref={oldTextRef}>
              <h4>1952</h4>
              <h3>Humble Beginnings</h3>
              <p>
                <em>Tulsidas Gordhandas Mistri</em> laid the foundation of the family’s legacy by starting a humble furniture business with a strong focus on craftsmanship, quality, and trust.
              </p>
            </div>
          </div>
          
          <div className="timeline"></div>

          <div className="timeline-item new">
            <div className="text" ref={newTextRef}>
              <h4>2024</h4>
              <h3>Expanding Craftsmanship</h3>
              <p>
                Today, under <em>Chiragbhai’s</em> leadership, the business has grown into a successful and reputed name in the furniture industry, blending heritage with innovation.
              </p>
            </div>
            <div className="timeline-point"></div>
            <div className="image" ref={newImgRef}>
              <img src={newimg} alt="New Shop" className="box-shadow" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
